module.exports = __webpack_public_path__ + "static/media/photo 003.6f186d05.jpg";